export const API_URL = "/api";
//export const API_URL = "http://127.0.01:8000/api";
export const TOKEN_KEY = "refine-auth";
export const REFRESH_KEY = "refine-auth-refresh";
export const ROLES_KEY = "refine-auth-roles";